var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { store } from '../app';
import homePage from '../Views/homePage';
import productsPage from '../Views/productsPage';
import productDetailPage from '../Views/productDetailPage';
import errorPage from '../Views/errorPage';
import cartPage from '../Views/cartPage';
import orderConfirmation from '../Views/orderConfirmation';
import cartAlert from '../Views/cartAlert';
import { links, cartButtons, getCartBtns, getSortingOptions, sortingOptions } from './domElements';
var content = document.getElementById('content');
var routes = {
    '/': renderHomePage,
    '/products': renderProductsPage,
    '/cart': renderCartPage,
    '/productDetail': renderProductDetailPage,
    '/404': renderErrorPage,
};
export default function router(element) {
    links[element]().forEach(function (nav) {
        nav.addEventListener('click', function (e) {
            e.preventDefault();
            var target = e.target;
            var link = target.pathname;
            if (routes[link]) {
                routes[link]();
            }
            else {
                routes['/404']();
            }
        });
    });
}
function getProductComments(productId) {
    return __awaiter(this, void 0, void 0, function () {
        var currentProduct;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, store.catalog.findComments(productId)];
                case 1:
                    currentProduct = _a.sent();
                    return [2 /*return*/, currentProduct];
            }
        });
    });
}
function renderHomePage() {
    content.innerHTML = homePage();
    router('content');
}
function renderErrorPage() {
    content.innerHTML = errorPage();
    router('content');
}
function renderProductsPage() {
    content.innerHTML = productsPage();
    router('content');
    getSortingOptions();
    sortProductList();
    store.catalog.sorting.key == 'id' ? sortingOptions.sortKey.value = 'default' : sortingOptions.sortKey.value = store.catalog.sorting.key;
    sortingOptions.sortType.value = store.catalog.sorting.sortType;
    renderProductDetailPage();
    getCartBtns();
    addProductToCart();
}
function renderProductDetailPage() {
    var _this = this;
    cartButtons.details.forEach(function (btn) {
        btn.addEventListener('click', function (e) { return __awaiter(_this, void 0, void 0, function () {
            var productId, currentProduct;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        productId = parseInt(btn.dataset.productId);
                        return [4 /*yield*/, getProductComments(productId)];
                    case 1:
                        currentProduct = _a.sent();
                        content.innerHTML = productDetailPage(currentProduct);
                        router('content');
                        getCartBtns();
                        addProductToCart();
                        return [2 /*return*/];
                }
            });
        }); });
    });
}
function productAddedAlert(product) {
    var alertContainer = document.getElementById('alert-container');
    alertContainer.innerHTML += cartAlert(product);
}
function addProductToCart(render) {
    cartButtons.addToCart.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var productId = parseInt(btn.dataset.productId);
            var product = store.catalog.findById(productId);
            store.cart.add(product);
            if (render)
                renderCartPage();
            else
                productAddedAlert(product);
        });
    });
}
function substractFromCart() {
    cartButtons.substractFromCart.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var productId = parseInt(btn.dataset.productId);
            var product = store.catalog.findById(productId);
            store.cart.substract(product);
            renderCartPage();
        });
    });
}
function deleteFromCart() {
    cartButtons.deleteFromCart.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var productId = parseInt(btn.dataset.productId);
            var product = store.catalog.findById(productId);
            store.cart.delete(product);
            renderCartPage();
        });
    });
}
function confirmOrder() {
    var confirmBtn = document.getElementById('confirmOrder');
    var url = orderConfirmation();
    confirmBtn.addEventListener('click', function (e) {
        var _a;
        e.preventDefault();
        (_a = window.open(url, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
    });
}
function renderCartPage() {
    content.innerHTML = cartPage();
    router('content');
    getCartBtns();
    addProductToCart('render');
    substractFromCart();
    deleteFromCart();
    confirmOrder();
}
function sortProductList() {
    var sortOptions = [sortingOptions.sortKey, sortingOptions.sortType];
    sortOptions.forEach(function (opt) {
        opt.addEventListener('change', function () {
            var sortOrder = sortingOptions.sortType.value;
            var sortingKey;
            sortingOptions.sortKey.value == 'default' ? sortingKey = 'id' : sortingKey = sortingOptions.sortKey.value;
            store.catalog.sortByKey(sortingKey, sortOrder);
            renderProductsPage();
        });
    });
}
renderHomePage();
